
// MaintenanceTimer.jsx
import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from '@material-ui/core';

// Changez cette ligne :
const useStyles = makeStyles((theme) => ({
  timerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Oswald', sans-serif",
    marginTop: '2rem',
    lineHeight: '1.5',
    fontStretch: 'expanded',
  },
  timerBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 20px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 5px',
    },

  },
  timerBlockContent: {
    display: 'flex',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      gap: '5px'
    },
  },
  timerCard: {
    width: 80,
    height: 100,
    backgroundColor: '#464646',
    borderRadius: 5,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    [theme.breakpoints.down('sm')]: {
      width: 30,
      height: 50,
    },
  },
  timerCardUnit: {
    backgroundColor: '#464646',
  },
  front: {
    width: '100%',
    height: '100%',
    // position: 'absolute',
    backfaceVisibility: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '6rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
    color: 'white',
    fontFamily: "'Oswald', sans-serif",
  },
  span: {
    fontSize: '2rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
    fontFamily: "'Oswald', sans-serif",
    color: '#aaa',
    marginTop: 5,
  },
  value: {
    fontSize: '4rem',
    fontFamily: "'Oswald', sans-serif",
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    lineHeight: 2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
      marginTop: '0.5rem'
    },
  },
}));

const MaintenanceTimer = ({ maintenanceDateTime }) => {
  // Changez cette ligne aussi :
  const classes = useStyles();
  const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining());

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeRemaining(getTimeRemaining());
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [maintenanceDateTime]);

  function getTimeRemaining() {
    const maintenanceDateTimeObj = new Date(maintenanceDateTime);
    const now = new Date();
    const timeDiff = maintenanceDateTimeObj - now;

    if (timeDiff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const seconds = Math.floor((timeDiff / 1000) % 60);
    const minutes = Math.floor((timeDiff / 1000 / 60) % 60);
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return { days, hours, minutes, seconds };
  }

  const renderCard = (value, isUnit) => (
    <div className={`${classes.timerCard} ${isUnit ? classes.timerCardUnit : ''}`}>
      <div className={classes.front}>
        <span className={classes.value}>{value}</span>
      </div>
      <div className={classes.back}>
        <span className={classes.value}>{value}</span>
      </div>
    </div>
  );

  const renderBlock = (value, unitName) => {
    const dizaine = Math.floor(value / 10);
    const unite = value % 10;

    return (
      <div className={classes.timerBlock}>
        <div className={classes.timerBlockContent}>
          {renderCard(dizaine, false)}
          {renderCard(unite, true)}
        </div>
        <span className={classes.span}>{unitName}</span>
      </div>
    );
  };

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} className={classes.timerContainer}>
      {renderBlock(timeRemaining.days, 'Jours')}
      {renderBlock(timeRemaining.hours, 'Heures')}
      {renderBlock(timeRemaining.minutes, 'Minutes')}
      {renderBlock(timeRemaining.seconds, 'Secondes')}
    </Grid>
  );
};

export default MaintenanceTimer;
